import { useOrder } from "../../context/OrderContext";
import { PawPrint, Check } from "lucide-react";

export default function StepPetScreen() {
  const { state, update, goNext, goBack } = useOrder();
  const qty = state.quantity || 1;
  const on = !!state.petscreenAll;

  return (
    <div data-testid="step-petscreen">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2 text-[var(--brand-text)]">
        PetScreen™ Upgrade?
      </h1>
      <p className="muted-text mb-5">
        Heavy-duty pet-resistant mesh — claws and paws beware.
        <span className="block mt-1 brand-text font-semibold">+$25 per item</span>
      </p>

      <div className="space-y-3">
        <button type="button" data-testid="petscreen-yes"
          onClick={() => update({ petscreenAll: true })}
          className={`option-card w-full text-left ${on ? "selected" : ""}`}>
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-xl" style={{ background: "var(--brand-green-light)" }}>
              <PawPrint className="w-6 h-6 brand-text" />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-start">
                <p className="font-semibold text-[var(--brand-text)]">
                  Yes, upgrade all {qty} {qty === 1 ? "item" : "items"}
                </p>
                {on && <Check className="w-5 h-5 brand-text" />}
              </div>
              <p className="text-sm muted-text mt-1">+${(25 * qty).toFixed(0)} total ({qty} × $25)</p>
            </div>
          </div>
        </button>

        <button type="button" data-testid="petscreen-no"
          onClick={() => update({ petscreenAll: false })}
          className={`option-card w-full text-left ${!on ? "selected" : ""}`}>
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-xl bg-gray-100">
              <PawPrint className="w-6 h-6 text-gray-400" />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-start">
                <p className="font-semibold text-[var(--brand-text)]">No thanks, standard mesh</p>
                {!on && <Check className="w-5 h-5 brand-text" />}
              </div>
              <p className="text-sm muted-text mt-1">Stick with the standard, no extra charge.</p>
            </div>
          </div>
        </button>
      </div>

      <div className="flex gap-3 mt-8">
        <button data-testid="back-btn" type="button" onClick={goBack}
          className="flex-1 py-3 rounded-full border-2 border-[var(--brand-border)] font-semibold">
          Back
        </button>
        <button data-testid="continue-btn" className="cta-btn flex-1" onClick={goNext}>Continue</button>
      </div>
    </div>
  );
}
